import Vue from 'vue'
import Vuex from 'vuex'
import { app } from '@/main.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(28, 75, 144, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    drawer: null,
    host: {
      ip: "localhost",
      port: "80"
    },
    snackbar: { show: false, message: null, timeout: 3000 },
    overlay: { show: false },
    socket: {
      event: null
    },
    licensePlate: {
      searchCache: null
    },
    withDash: false,
  },
  mutations: {
    SET_BAR_COLOR(state, payload) {
      state.barColor = payload + ', rgba(0, 0, 0, .8)'
    },
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
    OPEN_SNACKBAR(state, payload) {
      state.snackbar.message = payload
      state.snackbar.show = true
    },
    CLOSE_SNACKBAR(state) {
      state.snackbar.show = false
    },
    OPEN_OVERLAY(state) {
      state.overlay.show = true
    },
    CLOSE_OVERLAY(state) {
      state.overlay.show = false
    },
    SET_LANGUAGE(state, payload) {
      app.$i18n.locale = payload // 改變語言
    },
    SET_WITHDASH(state, payload) {
      state.withDash = payload
    }
  },
  actions: {
    openSnackbar(context, options) {
      let timeout = context.state.snackbar.timeout

      context.commit('OPEN_SNACKBAR', options.message)

      setTimeout(() => {
        context.commit('CLOSE_SNACKBAR')
      }, timeout)
    },
    openOverlay(context) {
      context.commit('OPEN_OVERLAY')
    },
    closeOverlay(context) {
      context.commit('CLOSE_OVERLAY')
    },
    setLanguage(context, payload) {
      context.commit('SET_LANGUAGE', payload)
    },
    setWithDash(context, payload) {
      context.commit('SET_WITHDASH', payload)
    }
  },
})
